module.exports = __webpack_public_path__ + "static/media/money_formula.e583d2fe.png";